import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CallerService } from '../services/caller.service';
import { RETURN_URL_QUERY_PARAM, safeReturnUrl } from '../utils/return-url.util';

@Injectable({
  providedIn: 'root'
})
export class BasicAuthGuard implements CanActivate {
  constructor(private router: Router, private callerService: CallerService) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      console.log('authenticating');

      if (this.callerService.hasActiveSession()) {
        const corpMemberLocal = localStorage.getItem(CallerService.LOCAL_STORAGE_DATA_KEY)
        const foundData = JSON.parse(corpMemberLocal || '{}');
        if (foundData?.id || (foundData?.state_code && this.callerService.state_code_regex.test(foundData?.state_code))) {
          console.log('authenticated');
        
          return true;
        } else {
          console.log('no id or statecode or invalid statecode');
          this.callerService.showNotification("Invalid user. Please sign up.", undefined, "OK" , "bottom")
          return this.router.navigate(['/signup'])
        }
        
      } else {
        console.log('not authenticated');

        this.callerService.closeAllModals()
        this.callerService.showNotification("Session Expired. Login.", 3000, "OK" , "bottom")
        // Back here after logging in (e.g. a link from an email).
        const returnUrl = safeReturnUrl(state.url)
        return this.router.createUrlTree(['/login'], returnUrl ? { queryParams: { [RETURN_URL_QUERY_PARAM]: returnUrl } } : {})
      }
  }
  
}
